// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sfCq","textarea":"styles_textarea__UFu0S"};